import request from '@/utils/request';
import { AddTransactionPayload, ExecuteTransactionPayload, TransactionView } from '@/api/models/payment-gateway';

const transactionsPath = `${process.env.VUE_APP_BASE_API_AUTH}/payment-gateway/transactions`;

export const createTransaction = (data: AddTransactionPayload) => request.post<TransactionView>(transactionsPath, data);

export const executeTransaction = (id: string, data: ExecuteTransactionPayload) =>
  request.put<TransactionView>(`${transactionsPath}/${id}/execute`, data);
